navigator.serviceWorker?.register("/sw.js").then(() => location.reload());
